import * as React from 'react';
import { ReactNode } from 'react';

import { cn } from '@restworld/utils-common';
import { Heading } from '@restworld/ui-ds-base';
import { Button } from '@restworld/ui-ds-base';

type ButtonProps = {
  title: string;
  onClick: () => void;
};

type CommonModalWrapperProps = {
  mainTitle?: string;
  subTitle?: string;
  primaryButtonProps?: ButtonProps;
  secondaryButtonProps?: ButtonProps;
  isReversedHeadAndContent?: boolean;
  children?: ReactNode;
  loading?: boolean;
  icon?: ReactNode;
  textAlignment?: TextAlignment;
  additionalContent?: string;
};

export const CommonModalWrapper = ({
  mainTitle,
  subTitle,
  isReversedHeadAndContent,
  children,
  primaryButtonProps,
  secondaryButtonProps,
  loading,
  icon,
  textAlignment,
  additionalContent,
}: CommonModalWrapperProps) => (
  <div className="flex flex-col gap-8 w-full">
    {mainTitle && (
      <SecondWrapperDiv isReversed={isReversedHeadAndContent}>
        {icon ? <div className="mx-auto">{icon}</div> : null}
        <ThirdWrapperDiv textAlignment={textAlignment}>
          <Heading size={3} weight="semibold" className="leading-6.75">
            {mainTitle}
          </Heading>
          {subTitle ? (
            <Heading size={5} weight="normal" color="muted" className="leading-6">
              {subTitle}
            </Heading>
          ) : null}
          {additionalContent ? (
            <Heading size={5} weight="normal" color="muted">
              {additionalContent}
            </Heading>
          ) : null}
        </ThirdWrapperDiv>
        {children}
      </SecondWrapperDiv>
    )}
    <div className="flex flex-col gap-2 w-full">
      {primaryButtonProps ? (
        <Button loading={loading} variant="primary" fullwidth onClick={primaryButtonProps.onClick}>
          {primaryButtonProps.title}
        </Button>
      ) : null}
      {secondaryButtonProps ? (
        <Button variant="secondary-neutral" fullwidth onClick={secondaryButtonProps.onClick}>
          {secondaryButtonProps.title}
        </Button>
      ) : null}
    </div>
  </div>
);
const SecondWrapperDiv = ({ isReversed, className, ...props }: any) => (
  <div
    className={cn('flex flex-col gap-5 w-full items-center', isReversed ? 'flex-col-reverse' : 'flex-col', className)}
    {...props}
  />
);

const ThirdWrapperDiv = ({ textAlignment, className, ...props }: any) => (
  <div
    className={cn(
      'flex gap-2 flex-col max-w-sm w-full text-center items-center',
      textAlignment === 'left' ? 'text-left' : 'text-center',
      className
    )}
    {...props}
  />
);
type TextAlignment = 'center' | 'left';
